import React, { forwardRef } from "react";
import { ChevronDown } from "lucide-react";

export interface SelectFieldProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
  containerClassName?: string;
}

export const SelectField = forwardRef<HTMLSelectElement, SelectFieldProps>(
  function SelectField(
    {
      label,
      error,
      helperText,
      className = "",
      containerClassName = "",
      disabled,
      required,
      id,
      name,
      children,
      ...rest
    },
    ref
  ) {
    const selectId = id || name;

    return (
      <div className={`w-full ${containerClassName}`}>
        {label && (
          <label
            htmlFor={selectId}
            className="mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300"
          >
            {label}
            {required && <span className="ml-0.5 text-red-500">*</span>}
          </label>
        )}
        <div className="relative">
          <select
            id={selectId}
            name={name}
            ref={ref}
            disabled={disabled}
            className={`w-full appearance-none rounded-lg border bg-white px-3 py-2 pr-9 text-sm text-slate-900 shadow-sm transition-colors focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-400 dark:bg-slate-800 dark:text-slate-100 dark:disabled:bg-slate-900 dark:disabled:text-slate-600 ${
              error
                ? "border-red-400 focus:border-red-500 focus:ring-red-500/30"
                : "border-slate-300 focus:border-primary-500 focus:ring-primary-500/30 dark:border-slate-600"
            } ${className}`}
            {...rest}
          >
            {children}
          </select>
          <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        </div>
        {helperText && (
          <p
            className={`mt-1.5 text-xs ${
              error
                ? "text-red-500"
                : "text-slate-500 dark:text-slate-400"
            }`}
          >
            {helperText}
          </p>
        )}
      </div>
    );
  }
);
